/* eslint-disable @next/next/no-img-element */
import classNames from "classnames";
import HTMLReactParser from "html-react-parser";
import React, { useMemo, useState } from "react";

import { downloadImageFromURI } from "../../../../utils";
import { useAsyncLoadImage } from "../../../../utils/hooks/useAsyncLoadImage";
import { openHref } from "../../../../utils/openHref";

export interface ImageBlockData {
  file?: {
    url: string;
    name?: string;
  };
  url?: string;
  caption: string;
  withBorder: boolean;
  withBackground: boolean;
  stretched: boolean;
  [s: string]: any;
}

export interface ImageBlockConfig {
  actionsClassNames?: {
    [s: string]: string;
  };
}

interface ImageBlockProps extends ImageBlockConfig {
  data?: ImageBlockData;
  className?: string;
}

export default function Image(props: ImageBlockProps) {
  const {
    data,
    className = "",
    actionsClassNames = {
      stretched: "image-block--stretched",
      withBorder: "image-block--with-border",
      withBackground: "image-block--with-background",
    },
  } = props;
  const imageUrl = useAsyncLoadImage(data?.file?.url);
  const [fancyVisible, setFancyVisible] = useState(false);

  const configClassNames = useMemo(() => {
    const arr: string[] = [];

    Object.keys(actionsClassNames).forEach((actionName) => {
      if (data && data[actionName] === true) {
        arr.push(actionsClassNames[actionName]);
      }
    });

    return arr.join(" ");
  }, [actionsClassNames, data]);

  try {
    const handleDownload = (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      if (imageUrl) {
        downloadImageFromURI(imageUrl);
      }
    };

    const handleImageClick = () => {
      if (!imageUrl) return;
      if (data?.url) {
        openHref(data?.url);
        return;
      }
      setFancyVisible((prev) => !prev);
    };

    if (!data?.file?.url) {
      return <></>;
    }

    return (
      <figure
        className={classNames("image", className, configClassNames)}
        onClick={handleImageClick}
      >
        {imageUrl && (
          <div className={classNames("image__fancy", fancyVisible && "is-on")}>
            <div className="image__fancy-block">
              <em className="icon icon-close image__fancy-close" />
              <em
                className="icon icon-download image__fancy-download"
                onClick={handleDownload}
              />
              <img src={imageUrl} alt={data.caption || data.file.name} />
            </div>
          </div>
        )}

        {imageUrl ? (
          <img src={imageUrl} alt={data.caption || data.file.name} />
        ) : (
          <div
            className="skeleton"
            data-url={data.file?.url}
            style={{ height: 300, borderRadius: 20 }}
          ></div>
        )}
        {data?.caption && (
          <figcaption>{HTMLReactParser(data.caption)}</figcaption>
        )}
      </figure>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет Image: ${error}`);
    return <></>;
  }
}
